import { render, staticRenderFns } from "./Ujian.vue?vue&type=template&id=6a04b5a2"
import script from "./Ujian.vue?vue&type=script&lang=js"
export * from "./Ujian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports